module.exports = __webpack_public_path__ + "static/img/myqrcode.792db72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/myqrcode.png
// module id = +UgJ
// module chunks = 2